import React from 'react';
import { Hero } from './components/Hero';
import { StatsAndProof, ExtendedTestimonials } from './components/ProofSections';
import { PainPoints } from './components/PainPoints';
import { ProductOffer } from './components/ProductOffer';
import { Pricing } from './components/Pricing';
import { CostSection, FooterAndProofPopup, GuaranteeAndFaq } from './components/ClosingSections';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-brand-ink text-white" data-id="element-0" data-mp="2rikmp3jx47ah">
      <Hero data-id="element-1" data-mp="2mjpvpebsrcfa" />
      <StatsAndProof data-id="element-2" data-mp="2mjzmv58kvpmk" />
      <PainPoints data-id="element-3" data-mp="31b8j3x6zk98o" />
      <ProductOffer data-id="element-4" data-mp="31bs1tg4gn1nr" />
      <Pricing showAnchor data-id="element-5" data-mp="31c9tdzg6grpc" />
      <ExtendedTestimonials data-id="element-6" data-mp="31cjog1g2xp1w" />
      <GuaranteeAndFaq data-id="element-7" data-mp="2wjgpfdsj9neb" />
      <CostSection data-id="element-8" data-mp="2wj8cjlweui34" />
      <Pricing data-id="element-9" data-mp="2wip54z4dzc3c" />
      <FooterAndProofPopup data-id="element-10" data-mp="2wi5mthatqlos" />
      <MetaPixel data-id="element-11" data-mp="28tw62tsgwo4i" />
    </main>;
}